import React from 'react';
import { OptimizedImage } from '../common';
import { Bot, Zap, Shield } from 'lucide-react';

export const ProductsHeroSection: React.FC = () => {
  const features = [
    {
      icon: Bot,
      title: 'AI Agents',
      description: 'Intelligent agents that understand context, learn from interactions, and provide personalized assistance across all your tasks.',
      image: '/images/012.ai-agents..jpeg',
    },
    {
      icon: Zap,
      title: 'Smart Tools',
      description: 'Powerful AI-powered tools that integrate seamlessly into your workflow, enhancing productivity without complexity.',
      image: '/images/013.smart-tools.jpeg',
    },
    {
      icon: Shield,
      title: 'Safe AI',
      description: 'AI systems built with safety and ethics at their core, ensuring responsible and beneficial artificial intelligence.',
      image: '/images/014.safe-ai.jpeg',
    },
  ];

  return (
    <section className="px-4 md:px-16 py-16 md:py-24 lg:py-28 bg-Color-Scheme-1-Background">
      <div className="container mx-auto">
        {/* Hero Section */}
        <div
          className="text-center mb-16 md:mb-20 lg:mb-24"
        >
          <h1 className="mb-6 text-5xl md:text-6xl lg:text-7xl font-bold font-gabarito text-Color-Scheme-1-Text leading-tight">
            Our <span className="text-[#C97B5A]">Products</span>
          </h1>
          <p className="text-2xl md:text-3xl lg:text-4xl font-gabarito text-Color-Scheme-2-Text mb-6">
            What We're Building
          </p>
          <p className="text-lg md:text-xl text-Color-Scheme-1-Text font-cairo max-w-3xl mx-auto">
            At MindClave, we are dedicated to developing AI that enhances
            human capabilities. Our solutions simplify complex
            tasks, empowering users to achieve more in their everyday lives.
          </p>
        </div>

        {/* Features Section */}
        
        <div className="grid grid-cols-1 items-start gap-y-12 md:grid-cols-3 md:gap-x-8 lg:gap-x-12">
          {features.map((feature, index) => {
            return (
              <div
                key={index}
              >
                <div className="mb-6 md:mb-8 w-full aspect-[16/10] rounded-2xl overflow-hidden">
                  <OptimizedImage
                    src={feature.image} 
                    alt={feature.title} 
                    className="rounded-2xl"
                    sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  />
                </div>
                <h3 className="mb-5 text-2xl md:text-3xl font-bold font-gabarito text-Color-Scheme-2-Text md:leading-tight">
                  {feature.title}
                </h3>
                <p className="text-Color-Scheme-2-Text font-cairo">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};